/**
 * Stat card. Full-height left bar in the category ink, uppercase label, serif numeral.
 * The bar is an overlaid rectangle clipped by the card's own rounded corners, so its
 * outer edge tapers with the card radius while the inner edge stays perfectly straight.
 * `accent` accepts any colour — use the ink palette from the design brief.
 *   <StatCard label="Open issues" value="3" accent="#E63B7A" />
 * Optional `suffix` for fractions ("/ 3304").
 */
export const StatCard = ({ label, value, accent, suffix }) => (
  <div class="relative overflow-hidden rounded-sm border border-border-subtle bg-bg-card p-4">
    <span
      class="absolute inset-y-0 left-0 w-[3px]"
      style={{ background: accent }}
      aria-hidden="true"
    />
    <p class="label mb-2">{label}</p>
    <p class="m-0 font-serif text-[32px] font-medium leading-none tracking-tighter text-text-primary">
      {value}
      {suffix && (
        <span class="ml-0.5 font-sans text-sm font-medium text-text-muted">
          {' '}{suffix}
        </span>
      )}
    </p>
  </div>
);
